<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card">

        
        <h4>List of Task & Event Types</h4>
        
        <div class="p-mb-4 p-d-flex p-jc-between p-toolbar">
          <Button
            label="New Type"
            icon="pi pi-plus"
            class="p-button-success p-mr-2"
            style="margin-right: 1em"
            @click="openNew"
          />
          <div>
            <span class="p-input-icon-left">
              <i class="pi pi-search" />
              <InputText
                v-model="filters"
                placeholder="Global Search"
                style="margin-right: 0.5em"
                @input="updateSearch"
              />
            </span>
          </div>
        </div>

        <ActivityTypesTable
          :key="activityTypesKey"
          :activityTypes="activityTypes"
          :loading="loading"
          @edit-activity-type="editActivityType"
        />

        <ActivityTypeForm
          :activityTypeToEdit="activityType"
          :key="activityTypeFormKey"
          :activityTypeForm="activityTypeForm"
          :disabledArr="disabledArr"
          :colourCodes="colourCodes"
          @close="hideActivityTypeDialog"
          @save="saveActivityType"
        />

      </div>
    </div>
  </div>
</template>

<script>
import ActivityService from "@/service/ActivityService";

import ActivityTypesTable from './activityTypesTable'
import ActivityTypeForm from './activityTypeForm'

export default {
  components: {
    ActivityTypesTable,
    ActivityTypeForm
  },
  data: () => ({
    activityService: new ActivityService(),
    filters: '',
    activityTypesKey1: 0,
    activityTypes: [],
    activityTypeForm: false,
    activityTypeFormKey1: 0,
    disabledArr: [],
    activityType: {},
    colourCodes: [
      { id: 1, label: 'Blue', value: 'badge-primary' },
      { id: 2, label: 'Sky Blue', value: 'badge-info' },
      { id: 3, label: 'Gray', value: 'badge-secondary' },
      { id: 4, label: 'Green', value: 'badge-success' },
      { id: 5, label: 'Red', value: 'badge-danger' },
      { id: 6, label: 'Orange', value: 'badge-warning' },
      { id: 7, label: 'White', value: 'badge-light' },
      { id: 8, label: 'Black', value: 'badge-dark' },
    ],
    requesting: false
  }),
  computed: {
    activityTypesKey: {
      set(val) {
        this.activityTypesKey1++
      },
      get() {
        return 'ActivityTypesTable' + this.activityTypesKey1.toString()
      }
    },
    activityTypeFormKey: {
      set(val) {
        this.activityTypeFormKey1++
      },
      get() {
        return 'ActivityTypeForm' + this.activityTypeFormKey1.toString()
      }
    },
    loading() {
      if (this.activityTypes && this.activityTypes[0]) {
        return false
      } else {
        if (this.requesting) {
          return true
        } else {
          return false
        }
      }
    }
  },
  watch: {
    filters(val) {
      this.activityTypesKey++
    },
    activityTypeForm(val) {
      this.activityTypeFormKey++
    },
    activityResults(val) {
      if (val && Array.isArray(val)) {
        this.activityTypesKey++
      }
    }
  },
  created() {
    this.getAllActivityTypes()
    if (this.$route.query.search !== '') {
      this.updateSearch('')
    }
  },
  methods: {
    saveActivityType(activityType) {
      

      if (activityType.id) {

        this.activityService
          .editActivityType(activityType)
          .then(data => {
            this.$toast.add({
              severity: "success",
              summary: "Type updated",
              detail: "Type updated successfully.",
              life: 5000,
            })
          
            this.activityTypeForm = false
            this.getAllActivityTypes()
            this.getAllActiveActivityTypesByHard()
          })
          .catch(err => {
            
                  
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while editing the type",
              life: 5000,
            })
          })
      } else {
        this.activityService
          .saveActivityType(activityType)
          .then(data => {
            this.$toast.add({
              severity: "success",
              summary: "Type saved",
              detail: "Type saved successfully.",
              life: 5000,
            });
          
            this.activityTypeForm = false
            this.getAllActivityTypes()
            this.getAllActiveActivityTypesByHard()
          })
          .catch(err => {
            
                  
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while saving the type",
              life: 5000,
            })
          })
      }
    },
    hideActivityTypeDialog(activityType) {
      this.activityType = {}
      this.activityTypeForm = false
    },
    editActivityType(activityType) {
      this.activityType = activityType
      this.activityTypeForm = true
    },
    getAllActivityTypes() {
      this.requesting = true
      this.activityService
        .getAllActivityTypesByHard()
        .then(data => {
          this.requesting = false

          
          data.forEach(element => {
            if (element.colourCode)
              element.colourCode = this.colourCodes.find(code => code.value === element.colourCode)
          });
          this.activityTypes = data
        })
        .catch(err => {
          this.requesting = false
          
          
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting activity types",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "activityTypess"'
          })
        })
    },
    getAllActiveActivityTypesByHard() {
      this.activityService
        .getAllActiveActivityTypesByHard()
        .then(data => {})
        .catch(err => {
          
                
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "activeactivitytypes"'
          })
        })
    },
    updateSearch(e) {
      this.$router.push({ query: { search: e } });
    },
    openNew() {
      this.activityType = {}
      this.activityTypeForm = true
    }
  }
}
</script>

<style>

</style>